import { MapPin } from 'lucide-react';

interface Evento {
  id: string;
  nome: string;
  descricao: string | null;
  local: string | null;
  dataInicio: string;
  dataFim: string;
  ativo: boolean;
}

interface EventoCardProps {
  evento: Evento;
  onClick: () => void;
}

export function EventoCard({ evento, onClick }: EventoCardProps) {
  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  return (
    <div
      onClick={onClick}
      className="cursor-pointer rounded-lg border border-gray-200 border-l-4 border-l-primary-500 bg-white p-5 shadow-sm transition-all hover:shadow-md hover:border-gray-300"
    >
      {/* Título */}
      <h3 className="text-lg font-semibold text-gray-900 mb-1">
        {evento.nome}
      </h3>

      {/* Subtítulo - Local ou Descrição */}
      {evento.local ? (
        <div className="flex items-center gap-1.5 text-sm text-gray-500 mb-3">
          <MapPin className="h-4 w-4" />
          <span>{evento.local}</span>
        </div>
      ) : evento.descricao ? (
        <p className="text-sm text-gray-500 mb-3 line-clamp-1">
          {evento.descricao}
        </p>
      ) : (
        <div className="mb-3" />
      )}

      {/* Footer - Período e Status */}
      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-400 uppercase tracking-wide">
          {formatDate(evento.dataInicio)} - {formatDate(evento.dataFim)}
        </span>

        <div className="flex items-center gap-1.5">
          <span
            className={`h-2 w-2 rounded-full ${
              evento.ativo ? 'bg-green-500' : 'bg-gray-400'
            }`}
          />
          <span
            className={`text-sm ${
              evento.ativo ? 'text-green-600' : 'text-gray-500'
            }`}
          >
            {evento.ativo ? 'Ativo' : 'Encerrado'}
          </span>
        </div>
      </div>
    </div>
  );
}
